import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import SimpleSelect from '../../CSSComponent/dropdownselection'
import Grid from '@material-ui/core/Grid'
import CustomizedHeatMap from '../../CSSComponent/heatmap.js'


const heatMapGrid = [
    [2, 2, 3, 3, 3],
    [2, 2, 2, 3, 3],
    [1, 2, 2, 3, 3],
    [1, 1, 2, 2, 3],
    [1, 1, 1, 2, 2]
]
const RiskLikelihood = ['1 - Very Unlikely', '2 - Unlikely', '3 - Moderate','4 - Likely', '5 - Very Likely']
const RiskImpact = ['1 - Very Low', '2 - Low', '3 - Moderate', '4 - High', '5 - Very High']

class RiskRating extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'GrossLike': this.props.GrossLike,
            'GrossImpact': this.props.GrossImpact,
            'GrossRating': this.props.GrossRating,

            'ResidualLike': this.props.ResidualLike,
            'ResidualImpact': this.props.ResidualImpact,
            'ResidualRating': this.props.ResidualRating,

            'TargetLike': this.props.TargetLike,
            'TargetImpact': this.props.TargetImpact,
            'TargetRating': this.props.TargetRating

        }
    }


    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props !== prevProps) {
            this.setState({
                'GrossLike': this.props.GrossLike,
                'GrossImpact': this.props.GrossImpact,
                'GrossRating': this.props.GrossRating,

                'ResidualLike': this.props.ResidualLike,
                'ResidualImpact': this.props.ResidualImpact,
                'ResidualRating': this.props.ResidualRating,

                'TargetLike': this.props.TargetLike,
                'TargetImpact': this.props.TargetImpact,
                'TargetRating': this.props.TargetRating
            })
        }
    }

    handleRiskRatingSelect = (key, value) => {
        //console.log(key, value)
        this.setState({ [key]: value },()=>{
            this.props.submitChange(key, this.state[key])
            
            if (key.substring(0, 8) == 'Residual') {
                // Residual rating change
                // "4 - " is because the array vertically is inverted as display in the graph and ratings (eg. 5 - Very High is actually points to the 1st row)
                let likeIndex = 4 - RiskLikelihood.findIndex( item => item === this.state.ResidualLike)
                let impactIndex = RiskImpact.findIndex( item => item === this.state.ResidualImpact)
 
                let ratingvalue = heatMapGrid[likeIndex][impactIndex]
                let rating = ratingvalue === 1 ? 'Low' : ratingvalue === 2 ? 'Medium' : 'High'
                this.setState({ ResidualRating: rating }, ()=>{
                    this.props.submitChange('ResidualRating', this.state.ResidualRating)
                })

            } else if (key.substring(0, 6) == 'Target') {
                // Target rating change
                let likeIndex = 4 - RiskLikelihood.findIndex( item => item === this.state.TargetLike)
                let impactIndex = RiskImpact.findIndex( item => item === this.state.TargetImpact)
                
                let ratingvalue = heatMapGrid[likeIndex][impactIndex]
                let rating = ratingvalue === 1 ? 'Low' : ratingvalue === 2 ? 'Medium' : 'High'
                this.setState({ TargetRating: rating }, ()=>{
                    this.props.submitChange('TargetRating', this.state.TargetRating)
                })

            } else {
                // Gross rating change
                let likeIndex = 4 - RiskLikelihood.findIndex( item => item === this.state.GrossLike)
                let impactIndex = RiskImpact.findIndex( item => item === this.state.GrossImpact)
                
                let ratingvalue = heatMapGrid[likeIndex][impactIndex]
                let rating = ratingvalue === 1 ? 'Low' : ratingvalue === 2 ? 'Medium' : 'High'
                this.setState({ GrossRating: rating }, ()=>{
                    this.props.submitChange('GrossRating', this.state.GrossRating)
                })
            }
        })
        
    };

    render() {
        const { classes } = this.props;

        const heatmapdata = [{
            gross_likelhood: [this.state.GrossLike + 1],
            gross_impact: [this.state.GrossImpact + 1],
            residual_likelhood: [this.state.ResidualLike + 1],
            residual_impact: [this.state.ResidualImpact + 1],
            target_likelhood: [this.state.TargetLike + 1],
            target_impact: [this.state.TargetImpact + 1],
            risk_name: "R1"
        }]




        return(
            <div>
                <Typography variant = "h6"  align="left" className={classes.FormHeader}> B. Risk Rating </Typography>
                <Divider className={classes.FormDivider}/>
                <Grid container padding>
                    <Grid item md={7}>
                        <Typography variant = "h6"  align="left" className={classes.FormHeader}> B1. Gross Risk Rating: </Typography>

                        <SimpleSelect
                            submitChange={this.props.submitChange}
                            id = 'GrossLike'
                            header = 'Likelihood: '
                            option = {RiskLikelihood}
                            defaultoption={RiskLikelihood.findIndex(item => item == this.props.GrossLike)}
                            returnSelection={this.handleRiskRatingSelect}
                        />
                        <SimpleSelect
                            submitChange={this.props.submitChange}
                            id = 'GrossImpact'
                            header = 'Impact: '
                            option = {RiskImpact}
                            defaultoption={RiskImpact.findIndex(item => item == this.props.GrossImpact)}
                            returnSelection={this.handleRiskRatingSelect}
                        />
                        <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> Rating: </Typography>
                        <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> {this.state.GrossRating} </Typography>

                        <Typography variant = "h6"  align="left" className={classes.FormHeader}> B2. Residual Risk Rating: </Typography>
                        <SimpleSelect
                            submitChange={this.props.submitChange}
                            id = 'ResidualLike'
                            header = 'Likelihood: '
                            option = {RiskLikelihood} 
                            defaultoption={RiskLikelihood.findIndex(item => item == this.props.ResidualLike)}
                            returnSelection={this.handleRiskRatingSelect}
                        />
                        <SimpleSelect
                            submitChange={this.props.submitChange}
                            id = 'ResidualImpact'
                            header = 'Impact: '
                            option = {RiskImpact} 
                            defaultoption={RiskImpact.findIndex(item => item == this.props.ResidualImpact)}
                            returnSelection={this.handleRiskRatingSelect}
                        />
                        <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> Rating: </Typography>
                        <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> {this.state.ResidualRating} </Typography>

                        <Typography variant = "h6"  align="left" className={classes.FormHeader}> B3. Target Risk Rating: </Typography>
                        <SimpleSelect 
                            submitChange={this.props.submitChange}
                            id = 'TargetLike' header = 'Likelihood: '
                            option = {RiskLikelihood}
                            defaultoption={RiskLikelihood.findIndex(item => item == this.props.TargetLike)}
                            returnSelection={this.handleRiskRatingSelect}
                        />
                        <SimpleSelect 
                            submitChange={this.props.submitChange}
                            id = 'TargetImpact' header = 'Impact: '
                            option = {RiskImpact}
                            defaultoption={RiskImpact.findIndex(item => item == this.props.TargetImpact)}
                            returnSelection={this.handleRiskRatingSelect}
                        />
                        <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> Rating: </Typography>
                        <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> {this.state.TargetRating} </Typography>
                    </Grid>
    
    
                    <Grid item md={5} style={{textAlign:'center', transform: 'scale(0.7, 0.7)', transformOrigin: 'top'}}>
                        <CustomizedHeatMap map={heatMapGrid} rrdata = {heatmapdata} />
                    </Grid>
                </Grid>
            </div>
                    
        )
    }
}

export default withStyles(styles)(RiskRating);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/B.js